/** @file Deletes the keys of a record (or immer draft) that a predicate selects, without dynamic `delete`. */

/** Deletes every own key of `record` for which `drop(key, value)` is true. */
export function dropKeys(record: Record<string, unknown>, drop: (key: string, value: unknown) => boolean): void {
  for (const [key, value] of Object.entries(record)) if (drop(key, value)) Reflect.deleteProperty(record, key);
}
